// import $ from 'jquery';
// import ScrollDepth from 'scroll-depth';

$(() => {
  console.log('scrollDepth loaded...')
  const scrollDepth = new ScrollDepth({
    eventHandler(data) {
      ga('send', 'event', data.eventCategory + ' - ' + window.location.pathname, data.eventAction, data.eventLabel);
    }
  })
})
